export const Logo = ({ className = "h-9 w-9", light = false }) => {
  const id = light ? "norcev-logo-grad-light" : "norcev-logo-grad";
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={light ? "#60A5FA" : "#1D4ED8"} />
          <stop offset="100%" stopColor={light ? "#2DD4BF" : "#0D9488"} />
        </linearGradient>
      </defs>
      <path
        d="M10 38 V10 L34 38 V18"
        stroke={`url(#${id})`}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="38" cy="11" r="4.5" fill="#14B8A6" />
    </svg>
  );
};
